<div class="modal-header wk-sde__header">
    <h3 class="modal-title wk-sde__header-title">{{ "Settings.EditDashboard" | translate }}</h3>
    <wk-icon-filled-close-sprite-pds3 />
    <icon-pds3 name="wk-icon-filled-close" color="#fff" (click)="bsModalRef.hide()" class="wk-sde__header-icon" />
</div>
<div cg3-theme="PDS-v3" class="modal-body wk-sde__body">
    <div class="wk-sde__fields">
        <div class="wk-sde__field">
            @if (dashboard.Application) {
                <h4 class="wk-sde__field-title">{{ dashboard.Application }}</h4>
            }
            <div class="wk-sde__field-container">
                <label class="wk-sde__field-label" style="font-size: 16px">{{ "General.Name" | translate }}</label>
                <text-field-pds3 class="wk-sde__field-input">
                    <input
                        type="text"
                        id="input-id-2-1"
                        name="name"
                        #name="ngModel"
                        [(ngModel)]="dashboard.Title"
                        maxlength="50"
                        (keyup.enter)="submitForm()"
                        placeholder="{{ 'Placeholder.DashboardName' | translate }}"
                    />
                </text-field-pds3>
            </div>
        </div>
    </div>
    <div class="wk-sde__actions">
        <button class="btn-primary wk-sde__actions-save" (click)="submitForm()" [disabled]="dashboard.Title.trim().length === 0 || loading">
            @if (loading) {
                <app-loader [isOverlay]="false" size="button" />
            }
            {{ "Settings.Save" | translate }}
        </button>
        <button class="btn-secondary wk-sde__actions-cancel" (click)="bsModalRef.hide()">{{ "Settings.btnCancel" | translate }}</button>
    </div>
</div>
